export function durationSince(date) {
	const now = Date.now();

	const diff = now - date;
	// Negative dates will produce "30 days ago"
	if (diff <= 0) {
		return `00:00:00`;
	}

	const timespan = new Date(diff);
	const intl = new Intl.RelativeTimeFormat();

	// "n years ago"
	const years = timespan.getUTCFullYear() - 1970;
	if (years > 0) {
		return intl.format(-years, `year`);
	}

	// "n days ago"
	const days = timespan.getUTCDate() - 1;
	if (days > 0) {
		return intl.format(-days, `day`);
	}

	const hours = `${timespan.getUTCHours()}`.padStart(2, `0`);
	const minutes = `${timespan.getUTCMinutes()}`.padStart(2, `0`);
	const seconds = `${timespan.getUTCSeconds()}`.padStart(2, `0`);

	return `${hours}:${minutes}:${seconds}`;
}

// Asp.Net/HTTP requires forms posted as flattened objects where all keys are converted into period delimited trees
// IE { "foo": { "bar": "baz" } } => { "foo.bar": "baz" }
export function aspNetFlatten(obj, prefix) {
	let output = {};
	for (const key in obj) {
		let value = obj[key];
		if (typeof value === `function`) {
			continue;
		}

		const aspNetKey = prefix ? `${prefix}.${key}` : key;
		if (typeof value === `object` && value !== null && !Array.isArray(value)) {
			if (Array.isArray(value)) {
				// Array

				// TODO: Support arrays
			} else {
				// Js Object
				const flattened = aspNetFlatten(value, aspNetKey);
				output = { ...output, ...flattened };
			}
		}
		// null, undef, or normal Js Variable (string, number, etc)
		output[aspNetKey] = value;
	}

	return output;
}